export default __webpack_public_path__ + "static/logo-1.0.0.png";